import { ModalTypes } from "config/types/modals";
import React from "react";
import useAuth from "./useAuth";
import useModal from "./useModal";

/**
 * @function hook for checking user is verified or not
 * @returns function that checks
 * weather user is verified or not and then open verification modal accordingly
 */

const useOpenVerificationModal = (): (() => void) => {
  const { isAuthenticated, userDetails } = useAuth();
  const { onOpen, changeModalType, modalType } = useModal();
  const OpenVerificationModal = (): void => {
    if (modalType !== ModalTypes.VERIFICATION_CODE)
      changeModalType(ModalTypes.VERIFICATION_CODE);
    if (
      (userDetails as boolean) &&
      isAuthenticated &&
      userDetails?.is_email_verified === false
    ) {
      onOpen();
    }
  };

  return OpenVerificationModal;
};

export default useOpenVerificationModal;
